import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/new/down_active_icon.png'
import _imports_1 from '@/assets/img/new/down_icon.png'
import _imports_2 from '@/assets/img/new/collect_active_icon.png'
import _imports_3 from '@/assets/img/new/collect_icon.png'
import _imports_4 from '@/assets/img/new/null_icon.png'


const _withScopeId = n => (_pushScopeId("data-v-af3ec732"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home_box" }
const _hoisted_2 = { class: "top_box" }
const _hoisted_3 = { class: "seach_box" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-d-arrow-left" }, null, -1))
const _hoisted_5 = { class: "main_box" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["src"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { key: 2 }
const _hoisted_11 = { class: "collect_popup" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = {
  key: 0,
  src: _imports_0,
  alt: ""
}
const _hoisted_14 = {
  key: 1,
  src: _imports_1,
  alt: ""
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "下载", -1))
const _hoisted_16 = ["onClick"]
const _hoisted_17 = {
  key: 0,
  src: _imports_2,
  alt: ""
}
const _hoisted_18 = {
  key: 1,
  src: _imports_3,
  alt: ""
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "收藏", -1))
const _hoisted_20 = {
  key: 1,
  class: "null_box"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: ""
}, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "暂无数据", -1))
const _hoisted_23 = [
  _hoisted_21,
  _hoisted_22
]
const _hoisted_24 = {
  key: 2,
  class: "pagin_box pagin_box1 pagin_box2"
}
const _hoisted_25 = { class: "pagin_tiao" }

import { onMounted, reactive } from 'vue'
import { useRoute,useRouter } from 'vue-router'
import databanks from './hooks/data_menu' // 混入菜单栏
import { useStore } from 'vuex';
import Screen from "@/components/Screen/index.vue";
import { getAddCollect, getRemoveCollect } from '@/api/collect';
import { ElMessage } from 'element-plus';
import getFileTypeImg from '@/hooks/use_type_imgs'
import { fileHandle } from '@/hooks/file_preview_download'
import bus from '@/utils/bus';

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { onPreview, addExtension, downLoad, previewPic } = fileHandle()
const { isShow, GetDataList, GetDataMenu } = databanks()
let person: any = reactive ({
    menuList: [], // 年级列表
    parId: 0,// 父级id
    searchId: [],
    parme:[],
    AliasName:'',
    // 资料库列表
    data: {
        list: [],
        PageIndex: 1,
        PageSize: 10,
        total: 0
    }
})
const router = useRouter();
const route = useRoute();
const store = useStore()
onMounted(() => {
    // 判断是主页，头部不加背景色
    if (router.currentRoute.value.name !== 'teaIndex') {
        store.commit('setIsBg', true)
    }
    person.parId = Number(route.query.Id)
    person.AliasName = route.query.AliasName
    load()
})
// 获取切换的NAV数据
bus.on('eventActive', (item: any,index:number) => {
    person.AliasName=item.AliasName
    person.parme= [item.Id]
    load()
    GetDataList(person.data, person.parId, person.parme)
    localStorage.setItem("navActive",JSON.stringify(index))
})
// 获取左菜单数据
const load = async ()=>{
    if (person.parId) {
        const data = await GetDataMenu(person.parId, 2)
        if (data.length > 0) {
            person.menuList = data
            person.parme = [Number(person.menuList[0].Id)]
            GetDataList(person.data, person.parId, person.parme)
        }
    }
}
// 年级切换
const gradeMenu = (item: any) => {
    person.parme = [item.Id]
    GetDataList(person.data, person.parId, person.parme)
    person.data.PageIndex = 1
}

// 确认筛选
const okMenu = (lastId: number) => {
    person.parme = [lastId]
    GetDataList(person.data, person.parId, person.parme)
}

//收藏
const onCollection = async (row: any, index: number) => {
    if (row.IsCollection) {
        //取消收藏
        const res = await getRemoveCollect({ ObjId: row.Id, ObjType: 3 })
        if (res.Code === 200) {
            person.data.list[index].IsCollection = !person.data.list[index].IsCollection
            ElMessage.success('取消收藏成功')
        } else {
            ElMessage.error(res.Message)
        }
    } else {
        //收藏
        const res = await getAddCollect({ ObjId: row.Id, ObjType: 3 })
        if (res.Code === 200) {
            person.data.list[index].IsCollection = !person.data.list[index].IsCollection
            ElMessage.success('收藏成功')
        } else {
            ElMessage.error(res.Message)
        }
    }
}
//查看图片
const previewPicClick = (row: any, index: number) => {
    if (row.DownState && row.Type === 4) {
        person.data.list[index].isPic = !person.data.list[index].isPic
    }
}

//下载图片
const dowmClick = (item: any, index: number) => {
    if (!item.DownState) {
        return
    }
    downLoad(item)
}

// 分页
const currentChange = (val: number) => {
    person.data.PageIndex = val
    GetDataList(person.data, person.parId, person.parme)
}

return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "seach_back",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).back()))
        }, [
          _hoisted_4,
          _createTextVNode(_toDisplayString(_unref(person).AliasName?_unref(person).AliasName:'暂无类别'), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_unref(person).menuList && _unref(person).menuList.length>0)
        ? (_openBlock(), _createBlock(Screen, {
            key: 0,
            class: "left_screen",
            onGradeMenu: gradeMenu,
            onOkMenu: okMenu,
            leftData: _unref(person).menuList
          }, null, 8, ["leftData"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "collect_scroll",
        style: _normalizeStyle(_unref(person).menuList && _unref(person).menuList.length > 0 ? 'width:77.5% !important;' :'width:100% !important;')
      }, [
        (!_unref(isShow)&&_unref(person).data.list&&_unref(person).data.list.length>0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(person).data.list, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "collect_item",
                  key: index
                }, [
                  _createElementVNode("div", {
                    class: "video_img",
                    onClick: ($event: any) => (_unref(onPreview)(item,index))
                  }, [
                    (item.Type !== 4)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: _unref(getFileTypeImg)(item.Extension),
                          alt: ""
                        }, null, 8, _hoisted_8))
                      : (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          onClick: ($event: any) => (previewPicClick(item,index))
                        }, [
                          _createVNode(_component_el_image, {
                            src: item.Url,
                            "preview-src-list": [item.Url],
                            "initial-index": 4,
                            fit: "cover",
                            ref_for: true,
                            ref_key: "previewPic",
                            ref: previewPic
                          }, null, 8, ["src", "preview-src-list"])
                        ], 8, _hoisted_9)),
                    _createElementVNode("span", {
                      class: _normalizeClass({Color:item.Type === 4})
                    }, _toDisplayString(_unref(addExtension)(item)), 3),
                    (item.ObjType===3)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString((item.Size/1024).toFixed(2)) + "M", 1))
                      : _createCommentVNode("", true)
                  ], 8, _hoisted_7),
                  _createElementVNode("div", _hoisted_11, [
                    (item.ObjType===3)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "collect_ite",
                          onClick: ($event: any) => (dowmClick(item,index))
                        }, [
                          (item.DownState)
                            ? (_openBlock(), _createElementBlock("img", _hoisted_13))
                            : (_openBlock(), _createElementBlock("img", _hoisted_14)),
                          _hoisted_15
                        ], 8, _hoisted_12))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", {
                      class: "collect_ite",
                      onClick: ($event: any) => (onCollection(item,index))
                    }, [
                      (item.IsCollection)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_17))
                        : (_openBlock(), _createElementBlock("img", _hoisted_18)),
                      _hoisted_19
                    ], 8, _hoisted_16)
                  ])
                ]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_20, _hoisted_23)),
        (_unref(person).data.total > _unref(person).data.PageSize)
          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
              _createVNode(_component_el_pagination, {
                layout: "prev, pager, next, jumper",
                "current-page": _unref(person).data.PageIndex,
                "page-size": _unref(person).data.PageSize,
                total: _unref(person).data.total,
                onCurrentChange: currentChange
              }, null, 8, ["current-page", "page-size", "total"]),
              _createElementVNode("div", _hoisted_25, "每页 " + _toDisplayString(_unref(person).data.PageSize) + " 条，共 " + _toDisplayString(_unref(person).data.total) + " 条", 1)
            ]))
          : _createCommentVNode("", true)
      ], 4)
    ])
  ]))
}
}

})